import { useLayoutEffect, useRef, useState, type RefObject } from 'react';
import { flushSync } from 'react-dom';

/** Ширина колонки главной (`.dash-board`), с которой верх — две независимые колонки (ТЗ перепланировки, § 3.1). */
export const WIDE_BOARD_MIN = 880;

/**
 * Раскладка верха главной по ширине колонки (ТЗ перепланировки верха 2026-10-26, § 5; вариант A — владелец). От 880 px
 * слева тренировка, игра и «новое слово», справа «На сегодня» и грамматика — порядок блоков в DOM другой, поэтому решает
 * скрипт, а не только CSS: `display: contents` и `order` развели бы порядок фокуса с видимым. Первый замер — до первой
 * отрисовки (useLayoutEffect), дальше — ResizeObserver (смена окна, сворачивание меню). Порог 640 — контейнерным
 * запросом в DashboardPage.css.
 */
export function useWideBoard(ref: RefObject<HTMLElement>): boolean {
  const [wide, setWide] = useState(false);
  const wideRef = useRef(false);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const apply = (width: number, sync: boolean) => {
      const next = width >= WIDE_BOARD_MIN;
      if (next === wideRef.current) return;
      wideRef.current = next;
      // Из ResizeObserver — до отрисовки кадра: иначе кадр стоит с сеткой одной раскладки и порядком блоков другой.
      if (sync) flushSync(() => setWide(next));
      else setWide(next);
    };
    apply(el.getBoundingClientRect().width, false);
    const ro = new ResizeObserver((entries) => {
      const entry = entries[entries.length - 1];
      if (entry) apply(entry.contentRect.width, true);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
  return wide;
}
